import { GeoPointType } from '@/@types';

const earthRadiusKm = 6371;

export const degreesToRadians = (degrees: number) => {
  return (degrees * Math.PI) / 180;
};

// https://www.movable-type.co.uk/scripts/latlong.html
export const distanceBetweenGeopoints = (point1: GeoPointType, point2: GeoPointType) => {
  const latitudDifference = degreesToRadians(point2.lat - point1.lat);
  const longitudeDifferencce = degreesToRadians(point2.lng - point1.lng);

  const latitude1InRadians = degreesToRadians(point1.lat);
  const latitude2InRadians = degreesToRadians(point2.lat);

  const a =
    Math.sin(latitudDifference / 2) ** 2 + Math.sin(longitudeDifferencce / 2) ** 2 * Math.cos(latitude1InRadians) * Math.cos(latitude2InRadians);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(earthRadiusKm * c * 1000);
};
